<nz-spin [nzSpinning]="pendingSpinner" [nzSize]="'large'" nzTip="Getting pending pay..." style="min-height: 200px; padding: 10px;">
  <nz-card class="widget highlight" nzBordered="false">
    <div class="widget-heading">
      <nz-badge nzStatus="success" nzText="Pending Pay"></nz-badge>
    </div>
    <div class="user-switcher" *ngIf="associations?.length">
      <nz-select
        nzShowSearch
        nzAllowClear
        [ngModel]="selectedUserId"
        (ngModelChange)="onUserChange($event)"
        nzPlaceHolder="View pay for...">
        <nz-option *ngFor="let assoc of associations" [nzValue]="assoc.id" [nzLabel]="(assoc.name | titlecase)"></nz-option>
      </nz-select>
    </div>
    <nz-descriptions *ngIf="totals" nzSize="small" [nzColumn]="1" nzBordered>
      <nz-descriptions-item nzTitle="Commissions">
        <span [ngStyle]="{ color: asNumber(totals.commission) >= 0 ? '#22c55e' : '#ef4444' }">{{ totals.commission | currency }}</span>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Adjustments">
        <span [ngStyle]="{ color: asNumber(totals?.commission_adjustment) >= 0 ? '#22c55e' : '#ef4444' }">{{ totals.commission_adjustment | currency}}</span>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Holdbacks">
        <span [ngStyle]="{ color: asNumber(totals?.HB) >= 0 ? '#22c55e' : '#ef4444' }">{{ totals.HB | currency}}</span>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Total">
        <span [ngStyle]="{ color: asNumber(totals?.total) >= 0 ? '#22c55e' : '#ef4444' }">{{ totals.total | currency }}</span>
      </nz-descriptions-item>
    </nz-descriptions>
  </nz-card>

<input nz-input placeholder="Search customer" [(ngModel)]="searchText" (ngModelChange)="onSearch()" style="margin-bottom: 16px; width: 300px;" />

<button nz-button nzType="default" (click)="downloadPending()">
    <span nz-icon nzType="download" nzTheme="outline"></span>
  </button>

<nz-table #nzTable [nzData]="filteredPendingPay">
    <thead>
      <tr>
        <th nzWidth="60px"></th>
        <th>Customer</th>
        <th>Rep</th>
        <th>Potential Pay Date</th>
        <th>Amount</th>
      </tr>
    </thead>
  
    <tbody>
      <ng-container *ngFor="let data of nzTable.data; trackBy: trackById">
        <tr>
          <td
            [nzExpand]="expandSet.has(data.work_order_id)"
            (nzExpandChange)="onExpandChange(data.work_order_id, $event)">
          </td>
          <td>{{ data.customer }}</td>
          <td>{{ data.rep }}</td>
          <td>{{ data.potential_pay_date | date}}</td>
          <td [ngStyle]="{ color: asNumber(data.amount) >= 0 ? '#22c55e' : '#ef4444' }">{{ data.amount | currency }}</td>
        </tr>
        <tr *ngIf="expandSet.has(data.work_order_id)">
            <td colspan="4">
                <nz-descriptions nzSize="small" [nzColumn]="1" nzBordered>
                    <nz-descriptions-item *ngFor="let subData of data.groupedData" [nzTitle]="subData.pay_type">
                      <span [ngStyle]="{ color: asNumber(subData.amount) >= 0 ? '#22c55e' : '#ef4444' }">{{ subData.amount  | currency }}</span>  
                      ({{subData.note}})
                    </nz-descriptions-item>
                    <nz-descriptions-item nzTitle="Total">
                      <span [ngStyle]="{ color: asNumber(data.amount) >= 0 ? '#22c55e' : '#ef4444' }">{{ data.amount | currency }}</span>
                    </nz-descriptions-item>
                  </nz-descriptions>
            </td>
          </tr>
      </ng-container>
    </tbody>
  </nz-table>
  
</nz-spin>
